var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/aaronphy/gitlab/lazada/node_modules/_nunjucks-loader@2.4.8@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/baseui/templates/orderItem.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-order-item J_Order\" data-id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\" data-type=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "type"), env.opts.autoescape);
output += "\" data-json=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "json"), env.opts.autoescape);
output += "\" role=\"option\" tabindex=\"0\" aria-label=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "sku"), env.opts.autoescape);
output += "，总价¥";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "amount"), env.opts.autoescape);
output += "，个数";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "buyAmount"), env.opts.autoescape);
output += "，当前状态";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "payStatusStr"), env.opts.autoescape);
output += "\">\n  <div class=\"pic\" aria-hidden=\"true\">\n    <img src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "picUrl"), env.opts.autoescape);
output += "\" aria-hidden=\"true\"/>\n  </div>\n  <div class=\"info\" aria-hidden=\"true\">\n    <div class=\"title\" aria-label=\"商品标题\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
output += "</div>\n    <div class=\"sku\" aria-label=\"商品规格\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "sku"), env.opts.autoescape);
output += "</div>\n    <div class=\"price\">\n      <span class=\"truly\" aria-label=\"商品成交价格\">¥";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "amount"), env.opts.autoescape);
output += "</span>\n      <s class=\"falsely\" aria-label=\"商品原价\">¥";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "price"), env.opts.autoescape);
output += "</s>\n      <span class=\"count\" aria-label=\"购买数量\">x";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "buyAmount"), env.opts.autoescape);
output += "</span>\n      <span class=\"status\" aria-label=\"交易状态\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "payStatusStr"), env.opts.autoescape);
output += "</span>\n    </div>\n  </div>\n  ";
if(runtime.contextOrFrameLookup(context, frame, "showDetail")) {
output += "\n  <button aria-label=\"点击查看详情\">详情</button>\n  ";
;
}
output += "\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/baseui/templates/orderItem.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/component/baseui/templates/orderItem.html
// module id = 152
// module chunks = 0 1